const HomeAnnatelURL = () => {
  const url = window.location.href
  if (url.includes('annatel.net')){
    return "https://www.annatel.net/fr_FR/"
  }

  if (url.includes('annatel.us')){
    return "https://www.annatel.us/en_US/"
  }

  return "https://www.annatel.co.il/fr_FR/"
}
export default HomeAnnatelURL;



// WEBPACK FOOTER //
// ./src/localeAssets/HomeAnnatelURL.js